import { useCallback, useEffect, useState } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import { useParams } from "react-router-dom";
import Translator from "../../../components/helpers/Translator";
import { axiosPath } from "../../../../routing/helpers/router";
import useIsMounted from "../../../components/hooks/useIsMounted";
import { AppNotificationAlert, AppRemixIcon } from "@/layout/AppComponents";
import _ from "lodash";

export default function Observations({ reportType }) {
  const { moduleBridgeHex, subModuleBridgeHex, plantHex } = useParams();
  const isMounted = useIsMounted();
  const [observations, setObservations] = useState("");

  const loadObservations = useCallback(async () => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_comsaReports_getObservations"),
        { type: reportType, moduleBridgeHex, subModuleBridgeHex, plantHex }
      );
      return response.data;
    } catch (err) {}
  }, []);

  const updateObservations = useCallback(async () => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_comsaReports_setObservations"),
        {
          type: reportType,
          moduleBridgeHex,
          subModuleBridgeHex,
          plantHex,
          observations,
        }
      );
      return response.data;
    } catch (err) {}
  }, [observations]);

  useEffect(() => {
    loadObservations().then((res) => {
      if (isMounted.current) setObservations(!_.isEmpty(res) ? res : "");
    });
  }, []);

  const handleUpdateObservations = () => {
    updateObservations().then(() => {
      if (isMounted.current)
        AppNotificationAlert({
          title: <Translator file="module-comsaReports" name="saved" />,
          message: (
            <Translator file="module-comsaReports" name="report.saved" />
          ),
          type: "success",
          position: "top-right",
          duration: 10000,
        });
    });
  };

  return (
    <div className="row mt-3">
      <div className="col-12 col-sm-6 offset-sm-6">
        <InputGroup className="mb-3">
          <FormControl
            placeholder={ReactDOMServer.renderToString(
              <Translator file="module-comsaReports" name="type.observations" />
            )}
            onChange={(e) => setObservations(e.target.value)}
            value={observations}
          />
          {observations && (
              <span
                className="btn btn-info ml-2"
                onClick={handleUpdateObservations}
                title={ReactDOMServer.renderToString(
                  <Translator file="module-comsaReports" name="edit" />
                )}
              >
                <AppRemixIcon icon="edit-box" />
              </span>
          )}
        </InputGroup>
      </div>
    </div>
  );
}
